/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = function _default(_ref) {
  var size = _ref.size,
    scrollTop = _ref.scrollTop,
    count = _ref.count,
    rowHeightManager = _ref.rowHeightManager,
    naturalRowHeight = _ref.naturalRowHeight,
    showEmptyRows = _ref.showEmptyRows;
  var start = rowHeightManager.getRowAt(scrollTop);
  var end = naturalRowHeight ? rowHeightManager.getRowAt(scrollTop + size.height) + 1 : start + Math.ceil(size.height / rowHeightManager.getDefaultRowHeight());
  if (!showEmptyRows) {
    end = Math.min(count - 1, end);
  }
  return {
    start: start,
    end: end
  };
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/react-virtual-list-pro/src/getVisibleRange.js
// module id = 759
// module chunks = 0